import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Dropdown from "../../UI/Dropdown/Dropdown";

const AssociationInfo = (props) => {
  const dropdownData = [
    {
      id: 1,
      value: "Revizorsko društvo",
    },
    { id: 2, value: "Samostalni revizor" },
  ];

  const mappedDropdownData = dropdownData.map((element) => {
    return (
      <option key={element.id} value={element.id}>
        {element.value}
      </option>
    );
  });

  const { userData } = props.parentState.newFormData;
  const { oibValidated } = userData;

  return (
    <>
      <Row>
        <Col>
          <Dropdown
            readOnly={props.disabled}
            style={props.parentState.error && userData.vrDrustva < 1 && "red"}
            label={"Vrsta subjekta*"}
            onChange={props.revisorDropdownHandler}
            hidden
            value={userData.vrDrustva}
            asProperty="select"
            map={mappedDropdownData}
            text="Odabir vrste"
          />
        </Col>
        <Col>
          <InputComponent
            disabled={props.disabled || userData.idBroj.length > 0}
            style={
              props.required &&
              props.parentState.error &&
              userData.oib.length < 1 &&
              userData.idBroj.length < 1 &&
              "red"
            }
            minLength={11}
            maxLength={11}
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.oib}
            controlLabel="OIB*"
            id={"oib"}
            name="oib"
          />
          {!oibValidated &&
            userData.oib.length <= 11 &&
            userData.oib.length > 0 && (
              <p style={{ color: "red" }}>
                OIB je neispravan! Molimo unesite ispravan OIB!
              </p>
            )}
        </Col>
        <Col>
          {" "}
          <InputComponent
            required={
              userData.oib.length < 1 ||
              (userData.oib.length > 0 && userData.idBroj.length > 0)
            }
            disabled={props.disabled || userData.oib.length > 0}
            style={
              props.required &&
              props.parentState.error &&
              userData.idBroj.length < 1 &&
              userData.oib.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.idBroj}
            id="idBroj"
            name="idBroj"
            controlLabel={"Identifikator"}
          ></InputComponent>
        </Col>
      </Row>
      <Row>
        {userData.vrDrustva == 1 && (
          <>
            <Col className="col-lg-8 input-style ">
              <InputComponent
                style={
                  props.required &&
                  props.parentState.error &&
                  userData.nazDrustva.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                id={"nazDrustva"}
                name="nazDrustva"
                value={userData.nazDrustva}
                controlLabel="Naziv društva*"
              ></InputComponent>
            </Col>
            <Col></Col>
            <Col></Col>
          </>
        )}
        {userData.vrDrustva == 2 && (
          <>
            <Col>
              <InputComponent
                style={
                  props.required &&
                  props.parentState.error &&
                  userData.prezime.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                id={"prezime"}
                name="prezime"
                value={userData.prezime}
                controlLabel="Prezime*"
              />
            </Col>
            <Col>
              <InputComponent
                style={
                  props.required &&
                  props.parentState.error &&
                  userData.ime.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                id={"ime"}
                name="ime"
                value={userData.ime}
                controlLabel="Ime*"
              />
            </Col>
            <Col></Col>
          </>
        )}
      </Row>
    </>
  );
};

export default AssociationInfo;
